import { PnkAjax } from '../pnk-react/ajax/pnk-ajax';

// function CheckToken(resp) {

//     // let timeToLogout = (new Date((localStorage.getItem('login_token_expire_time')))).getTime() - (new Date()).getTime();
//     // alert(timeToLogout)
//     // setTimeout(() => {
//     //     localStorage.clear();
//     //     // window.location.reload();
//     //     resp(false);
//     // }, timeToLogout);
// }

// create new organizer route

export function AddOrganizerData(store, userObj, successFunc) {

    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('organizers/json').ExtraData(userObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
}

// get organizer list route

export function GetOrganizersList(store, successFunc) {
    //  alert(localStorage.getItem('current_user_login_token'))
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('organizers/json').AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

// get organizer details route
export function OrganizerDetails(store, organizer_id, successFunc, from = '') {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('organizer/json/' + organizer_id + '/' + from).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
}

// update organizer details route
export function UpdateOrganizerDetails(store, organizer_id, editObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Put('organizer/json/' + organizer_id).ExtraData(editObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}